module.exports = __webpack_public_path__ + "static/CTO-9e09919056f81ed13f2de5d3cee82a41.png";